import "./reconnecting.css";
import {t, TKeys} from "../../translationService";

export const showReconnectingModal = () => document.getElementById("reconnectingModal").style.display = "flex";
export const hideReconnectingModal = () => document.getElementById("reconnectingModal").style.display = "none";

export const ReconnectingModal = () => {
    return <div id={"reconnectingModal"}>
        <div className={"content"}>
            <img src={"./assets/singleIcons/wifiAnimation.svg"}/>
            <div id={"reconnectingText"}>
                {t(TKeys.RECONNECTING)}...
            </div>
        </div>
    </div>
}